import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { teamTabTypes } from "@/util";
import { TabList, SidebarGrid } from "@/components/common";
import { TeamButtons, TeamDisplay } from "@/components/organization/save";
import { TeamMemberTable } from "@/components/members";
import { ProjectVersionStepper } from "@/components/project";


/**
 * Tabs for changing team settings.
 */
const __default__ = {
  name: "TeamTabs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tabs = teamTabTypes();

const tab = ref(tabs[0].id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarGrid), null, {
    sidebar: _withCtx(() => [
      _createVNode(_unref(TeamButtons)),
      _createVNode(_unref(TeamDisplay))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TabList), {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        tabs: _unref(tabs)
      }, {
        members: _withCtx(() => [
          _createVNode(_unref(TeamMemberTable))
        ]),
        projects: _withCtx(() => [
          _createVNode(_unref(ProjectVersionStepper), { "team-only": "" })
        ]),
        _: 1
      }, 8, ["modelValue", "tabs"])
    ]),
    _: 1
  }))
}
}

})